/**
 * Product gallery videos
 *
 * Keeps carousel videos in sync with the active Swiper slide, and fills in the
 * missing toggleVideoPlay handler referenced by tool.video. Scoped to
 * [data-product-gallery] so other theme videos are untouched.
 */
(function () {
  'use strict';

  var GALLERY = '[data-product-gallery]';
  var VIDEO = '.c-product-gallery__swiper video.c-product-gallery__media';

  if (typeof window.toggleVideoPlay !== 'function') {
    window.toggleVideoPlay = function (video) {
      if (!video || video.tagName !== 'VIDEO') return;

      if (video.paused) {
        ensureMuted(video);
        video.play().catch(function () {});
      } else {
        video.pause();
      }
    };
  }

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  }

  function ensureMuted(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
  }

  function syncGallery(gallery) {
    toArray(gallery.querySelectorAll(VIDEO)).forEach(function (video) {
      ensureMuted(video);

      var slide = video.closest('.swiper-slide');
      var active = !!(slide && slide.classList.contains('swiper-slide-active'));

      if (active) {
        if (video.paused) {
          video.play().catch(function () {});
        }
      } else if (!video.paused) {
        video.pause();
      }
    });
  }

  function bindGallery(gallery) {
    if (gallery.getAttribute('data-gallery-video-bound') != null) return;

    gallery.setAttribute('data-gallery-video-bound', '');
    syncGallery(gallery);

    var timer = null;

    function scheduleSync() {
      if (timer) clearTimeout(timer);
      // Wait for Swiper to finish swapping the active class.
      timer = setTimeout(function () {
        syncGallery(gallery);
      }, 50);
    }

    var observer = new MutationObserver(scheduleSync);

    observer.observe(gallery, {
      attributes: true,
      attributeFilter: ['data-index'],
    });

    var swiper = gallery.querySelector('[data-gallery-swiper-container]');

    if (swiper) {
      observer.observe(swiper, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class'],
      });
    }
  }

  function init() {
    toArray(document.querySelectorAll(GALLERY)).forEach(bindGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Swiper may finish init after the first pass.
  window.addEventListener('load', init);
  setTimeout(init, 500);
})();
